import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import {
  CartItem,
  Portfolio,
  ProductLineAttr,
} from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';

export interface PortfolioToCartItem {
  portfolio: Portfolio;
  cartItem: CartItem;
}

export interface PortfolioItemsByProductLine {
  productLineId: ProductLineId;
  portfolioToCartItems: PortfolioToCartItem[];
  productLineAttributes: ProductLineAttr[];
}

export const INITIAL_PORTFOLIO: Portfolio = {
  id: '',
  name: '',
  displayOrder: 0,
  products: [],
  marketingTagIds: [],
  bcVersions: {},
  advantages: [],
  productLineId: 'GroupDental',
  rateSegment: 'GROUP',
  currentApplications: {
    effectiveDate: '',
    defaultBrowsingCriteria: new Map(),
    forms: {
      addBenefitIds: [],
      eStoreConfigIds: [],
      contributionFormIds: [],
      individualFormIds: [],
      companyInfoFormIds: [],
      webFormIds: [],
      cancelCoverageFormIds: [],
      configurationFormIds: [],
      renewIds: [],
    },
    pdfs: {
      pdfIds: [],
      electedPdfIds: [],
      conditionalPdfs: [],
    },
  },
  configurable: false,
  eStoreTagId: '',
  catalogId: '',
};

export const INITIAL_CART_ITEM: CartItem = {
  portfolioId: '',
  portfolioName: '',
  productLineId: 'GroupDental',
  confirmed: false,
  selectedIndex: 0,
  browsingCriteria: {},
  equalsWithLastUpdateBCIndex: 0,
};
